import HowInsertVideo from './HowInsertVideo';

export default HowInsertVideo;